const MinesweeperVersusPaths = {
  home: "/",
  singleplayerRanked: "/singleplayer/ranked",
  singleplayerOffline: "/singleplayer/offline",
  multiplayerClassic: "/multiplayer/classic"
};

export default MinesweeperVersusPaths;
